import { ReactNode } from 'react';
import styled from 'styled-components';

import { SpacingTypes } from '@folx-types/theme';

import theme from '@theme/FolxTheme';

export interface IFlexColumn {
	children?: ReactNode;
	gap?: SpacingTypes;
	fullWidth?: boolean;
}

export default styled.div<IFlexColumn>`
	display: flex;
	flex-flow: column;
	gap: ${({ gap }) => !!gap && theme.spacing[gap]};
	width: ${({ fullWidth = false }) => !!fullWidth && '100%'};
`;
